import { isFinite } from '../lang';
import logFactory from '../logger';
var log = logFactory('');
export function validateEventValue(maybeValue, method) {
  if (isFinite(maybeValue) || maybeValue == undefined)
    // eslint-disable-line eqeqeq
    return maybeValue;
  log.error("".concat(method, ": value must be a finite number."));
  return false;
}